import React from "react";

const StatusBadge: React.FC<{
  status?: string;
  code?: string;
  type?: "status" | "type";
}> = ({ status, code, type = "status" }) => {
  const getColor = () => {
    if (type === "type") {
      switch (status?.toUpperCase()) {
        case "CLAIM":
          return "bg-blue-100 text-blue-800";
        case "PAYMENT":
          return "bg-green-100 text-green-800";
        case "PROVIDER_ADJUSTMENT":
          return "bg-yellow-100 text-yellow-800";
        case "MEMBER_COVERAGE":
          return "bg-purple-100 text-purple-800";
        case "CLAIM_STATUS":
          return "bg-orange-100 text-orange-800";
        case "RECEIVER_STATUS":
          return "bg-indigo-100 text-indigo-800";
        case "PROVIDER_STATUS":
          return "bg-teal-100 text-teal-800";
        case "REQUEST":
          return "bg-cyan-100 text-cyan-800";
        case "ELIGIBILITY":
          return "bg-pink-100 text-pink-800";
        case "INVOICE":
          return "bg-amber-100 text-amber-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    }
    switch (status?.toUpperCase()) {
      case "PAID":
      case "PROCESSED":
        return "bg-green-100 text-green-800";
      case "DENIED":
      case "REJECTED":
        return "bg-red-100 text-red-800";
      case "PENDING":
        return "bg-yellow-100 text-yellow-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  if (!status && !code) return null;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium ${getColor()}`}
    >
      {status || code}
    </span>
  );
};

export default StatusBadge;
